import { TableContent, TextBlock } from "@prismicio/types-internal/lib/content"
import { TableCell as TTTableCell } from "@tiptap/extension-table-cell"
import { Node as ProseMirrorNode, type Schema } from "@tiptap/pm/model"

import { Paragraph } from "../../extensions"
import { getNodeFromSchema } from "../utils"
import { tableCellAttrs } from "./types"
import { mapTableCellToParagraph } from "./utils"

type TableRowBlock = TableContent["content"][number]
type TableCellOrHeaderBlock = TableRowBlock["content"][number]

export const TableCell = TTTableCell.extend({
  name: "tableCell",

  addAttributes() {
    return {
      ...this.parent?.(),
      key: { default: null },
    }
  },
})

export const tableCellConverter = {
  fromPrismic(schema: Schema) {
    return function (cell: TableCellOrHeaderBlock): ProseMirrorNode {
      const node = getNodeFromSchema(schema, TableCell.name)
      const colwidth = cell.columnWidth ? [cell.columnWidth] : null

      return node.create(
        { colspan: 1, rowspan: 1, colwidth, key: cell.key },
        cell.content.value.flatMap((block) => {
          return mapTableCellToParagraph(schema, block) ?? []
        }),
      )
    }
  },

  toPrismic(node: ProseMirrorNode): TableCellOrHeaderBlock {
    const content: TextBlock[] = []
    node.content.forEach((node) => {
      const textBlock = Paragraph.converter.toPrismic(node)
      if (TextBlock.is(textBlock)) content.push(textBlock)
    })

    const data = tableCellAttrs.parse(node.attrs)
    const [columnWidth] = data.colwidth ?? []

    return {
      key: data.key ?? crypto.randomUUID(),
      type: "tableCell",
      content: { __TYPE__: "StructuredTextContent", value: content },
      columnWidth,
    }
  },
}
